import { axios } from '@vyce/core/src/api';

import { Borough, Nationality, Tag } from '../../types';
import { CreateTagArgs, GetTagsArgs, PaginatedList } from '../types';
import config from '../config';

const URL = `${config.gatewayApiUrl}`;

export const getBoroughsRequest = () => {
  return axios.get<PaginatedList<Borough>>(
    `${URL}/public/v1/handbook/boroughs?is_in_capital=true&limit=1000&offset=0`
  );
};

export const fetchTagsRequest = ({ group = '', offset = 0, limit = 1000, short = true }: GetTagsArgs) => {
  const groupParam = group ? `group=${group}&` : '';
  return axios.get<PaginatedList<Tag>>(
    `${URL}/public/v1/handbook/tags?${groupParam}limit=${limit}&offset=${offset}&short=${short}`
  );
};

export const fetchNationalitiesRequest = () => {
  return axios.get<PaginatedList<Nationality>>(
    `${URL}/public/v1/handbook/nationalities?limit=500&offset=0&short=true`
  );
};

export const fetchLanguagesRequest = (token: string) => {
  return axios.get(`/handbook/languages?limit=500&offset=0&short=true`);
};

export const createTagRequest = ({ name, group }: CreateTagArgs) => {
  return axios.post<Tag>(`${URL}/public/v1/handbook/tags`, { name, group });
};

export const getTagListRequest = ({ group, substring }: { group: string; substring?: string }) => {
  return axios.get<PaginatedList<Tag>>(`${URL}/public/v1/handbook/tags`, {
    params: {
      group,
      substring,
    },
  });
};
